import type { DeviceGenre } from "@/constants/device";
import { cn } from "@/lib/cn";
import type { ComponentProps } from "react";
import { match } from "ts-pattern";
import { LabelXBase } from "../../../../components/LabelX";
import { AvatarDevice } from "../Avatar/AvatarDevice";

type Props = {
  genre: DeviceGenre;
  name: string;
  /**
   * アバター画像のURL（デバイスの画像が設定されていないことを考慮して、undefinedを許容する）
   */
  avatarUrl?: string;
  /**
   * ホバーしたら大きくなってほしいかどうか
   */
  hoverScale?: boolean;
  /**
   * デバイス管理番号
   */
  deviceTag?: string;
  /**
   * 資産タグを表示するかどうか
   */
  showAssetTag?: boolean;
  /**
   * 資産タグ（showAssetTagがtrueの場合に表示される）
   */
  assetTag?: string;
} & Omit<ComponentProps<typeof LabelXBase>, "label">;

/**
 * デバイスのアバターとラベルを表示するコンポーネント
 */
export function LabelDevice({
  avatarUrl,
  hoverScale,
  showAssetTag = false,
  assetTag,
  ...props
}: Props) {
  const size = match(props.size)
    .with("Default", () => 24 as const)
    .with("Large", () => 32 as const)
    .with("Small", () => 16 as const)
    .with("ExtraSmall", () => 12 as const)
    .otherwise(() => 24 as const);

  return (
    <LabelXBase
      {...props}
      label={props.name}
      subLabel={
        props.deviceTag || (showAssetTag && assetTag) ? assetTag : undefined
      }
    >
      <AvatarDevice
        src={avatarUrl}
        genre={props.genre}
        size={size}
        // hoverScaleが指定されているか、previewCardがある場合にhoverScaleをtrueにする
        hoverScale={hoverScale ?? !!props.previewCardContent}
        className={cn("shrink-0 bg-neutral-muted-fill")}
      />
    </LabelXBase>
  );
}
